import { createApi } from "@reduxjs/toolkit/query/react";

import type { IApiResponse } from "@/shared/interfaces/api-response.interface";

import customFetchBase from "../custom-fetch-base";

export interface IAdminUserOption {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

interface IGetAdminUsersResponse {
  users: IAdminUserOption[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const adminUsersApi = createApi({
  reducerPath: "adminUsersApi",
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    searchAdminUsers: builder.query<IAdminUserOption[], { search?: string; districtId?: string; limit?: number }>({
      query: ({ search, districtId, limit = 10 }) => ({
        url: "/admin/users",
        method: "GET",
        params: { search: search || undefined, districtId: districtId || undefined, limit },
      }),
      transformResponse: (result: IApiResponse<IGetAdminUsersResponse>) => result.data.users ?? [],
    }),
    getAdminUser: builder.query<IAdminUserOption, string>({
      query: (userId) => ({
        url: `/admin/users/${userId}`,
        method: "GET",
      }),
      transformResponse: (result: IApiResponse<IAdminUserOption>) => result.data,
    }),
  }),
});

export default adminUsersApi;

export const { useSearchAdminUsersQuery, useGetAdminUserQuery } = adminUsersApi;
